import { useState } from "react";
import { MonetisationModelForm } from "@/features/tools/MonetisationModelForm";
import { MonetisationModelResult } from "@/features/tools/MonetisationModelResult";
import { ToolPageLayout } from "@/features/tools/ToolPageLayout";
import { runMonetisationModelSuggester } from "@/features/tools/proToolApi";
import { toolPageMetadata } from "@/features/tools/toolMetadata";
import { useProToolPageData } from "@/features/tools/useProToolPageData";
import type {
  MonetisationModelOutput,
  MonetisationModelRequest,
} from "@/features/tools/proToolTypes";

const metadata = toolPageMetadata.monetisation_model_suggester;

export function MonetisationModelToolPage() {
  const {
    canUseProTools,
    results,
    projects,
    generatedBlueprints,
    isLoading,
    error,
    getToken,
    refreshResults,
  } = useProToolPageData();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [latestResult, setLatestResult] =
    useState<MonetisationModelOutput | null>(null);
  const [toolError, setToolError] = useState<string | null>(null);

  async function handleSubmit(input: MonetisationModelRequest) {
    setIsSubmitting(true);
    setToolError(null);

    try {
      const token = await getToken();
      const response = await runMonetisationModelSuggester(token, input);
      setLatestResult(response.result.output_payload as MonetisationModelOutput);
      await refreshResults();
    } catch {
      setToolError("We could not generate this right now. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <ToolPageLayout
      title={metadata.title}
      label={metadata.label}
      intro={metadata.intro}
      canUseProTools={canUseProTools}
      isLoading={isLoading}
      error={error}
      results={results}
      toolType={metadata.toolType}
      emptyResultsMessage={metadata.emptyResultsMessage}
    >
      <MonetisationModelForm
        projects={projects}
        generatedBlueprints={generatedBlueprints}
        isSubmitting={isSubmitting}
        error={toolError}
        onSubmit={(input) => void handleSubmit(input)}
      />

      {latestResult ? <MonetisationModelResult output={latestResult} /> : null}
    </ToolPageLayout>
  );
}
